<template>

    <div>
        <button class="b-product-table__product-label"
                @click="show"
                v-show="!show_collections"
                v-text="trans('show_button')"
        ></button>

        <span
                v-for="collection in collections"
                class="b-product-table__product-label"
                v-html="collection"
                v-show="show_collections"
        ></span>
    </div>

</template>

<script>
    import * as Functions from '../Functions';

    export default {
        props: ['current_route', 'id', 'translations'],
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        },
        data: function () {
            return {
                show_collections: false,
                collections: []
            };
        },
        methods: {
            trans(name, path = null) {
                return Functions.trans(this.translations, name, path);
            },
            show: function () {
                this.$http.get(this.current_route + '/' + this.id + '/get_collections')
                    .then(function (response) {
                        this.collections = response.data;
                        this.show_collections = true;
                    }, function (response) {
                        console.log(response);
                    });
            }
        }
    }
</script>
